"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipInfoSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var tooltip_info_1 = require("../../layout/viewmodel/tooltip_info");
var partition_spec_1 = require("./partition_spec");
var picked_shapes_1 = require("./picked_shapes");
exports.getTooltipInfoSelector = re_reselect_1.default([partition_spec_1.getPartitionSpec, picked_shapes_1.getPickedShapes], function (spec, pickedShapes) {
    return spec
        ? tooltip_info_1.getTooltipInfo(pickedShapes, spec.layers.map(function (l) { return l.nodeLabel; }), spec.valueGetter, spec.valueFormatter, spec.percentFormatter, spec.id)
        : tooltip_info_1.EMPTY_TOOLTIP;
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=tooltip.js.map